module.exports = __webpack_public_path__ + "static/img/Alex.Browne.5416866.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alex.Browne.jpg
// module id = WoCO
// module chunks = 0